const videos = [
  {
    id: 1,
    title: "Cabañas del Campo - Video 1",
    url: "https://www.youtube.com/embed/j6kaYjI2tw0?autoplay=0&mute=0",
  },
  {
    id: 2,
    title: "Cabañas del Campo - Video 2",
    url: "https://www.youtube.com/embed/JuVVhn_CuGc?autoplay=0&mute=0",
  },
  {
    id: 3,
    title: "Cabañas del Campo - Video 3",
    url: "https://www.youtube.com/embed/yftuJ3-IMv4?autoplay=0&mute=0",
  },
  {
    id: 4,
    title: "Cabañas del Campo - Video 4",
    url: "https://youtube.com/embed/9dgfU4No36Q?autoplay=0&mute=0",
  },
];

export default videos;
